module.exports = __webpack_public_path__ + "img/stock1.75696f35.png";